import useConfig from 'modules/config/state/use-config'
import { useGetLegacyCampaignQuery } from 'redux/services/campaign/legacy'

/**
 * @returns {boolean} Whether Google ReCaptcha is enabled for the current campaign
 */
const useReCaptchaEnabled = () => {
  const config = useConfig()
  const campaignId = config.campaignId

  // use legacy campaign endpoint due to issue
  // where /studio-campaign always returns "ENABLED" for reCaptcha settings
  const { data: campaign } = useGetLegacyCampaignQuery(campaignId as string, { skip: !campaignId })

  return campaign?.effective_recaptcha_settings === 'ENABLED'
}

export default useReCaptchaEnabled
